import { CheckCircle } from "lucide-react";
import BMImg from "../img/siur/logo.png";

const features = [
    "Indywidualne podejście do każdego projektu",
    "Bezpłatny pomiar i wycena",
    "Wysokiej klasy okucia",
    "Gwarancja i serwis",
];

const AboutSection = () => {
    return (
        <section id="o-nas" className="section-padding bg-card">
            <div className="container mx-auto">
                <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
                    <div>
                        <span className="inline-block text-primary font-medium tracking-widest uppercase text-sm mb-4">
                            O nas
                        </span>
                        <h2 className="font-display text-3xl md:text-4xl lg:text-5xl font-bold text-foreground mb-6">
                            Jakość i doświadczenie
                        </h2>
                        <p className="text-muted-foreground text-lg leading-relaxed mb-8">
                            Realizujemy indywidualne zamówienia na meble do domów i firm. Dbamy o detale i terminowość.
                        </p>

                        <ul className="space-y-4">
                            {features.map((feature, index) => (
                                <li
                                    key={index}
                                    className="flex items-center gap-3 text-foreground"
                                >
                                    <CheckCircle className="h-5 w-5 text-primary flex-shrink-0" />
                                    <span>{feature}</span>
                                </li>
                            ))}
                        </ul>
                    </div>

                    <div className="relative">
                        <div className="aspect-[4/3] bg-muted rounded-lg overflow-hidden">
                            <img 
                                className="w-full h-full object-cover"
                                alt="Bartkiewicz Meble"
                                src={BMImg}
                            />
                        </div>

                        <div className="absolute -bottom-6 -left-6 w-32 h-32 border-4 border-primary rounded-lg -z-10" />
                    </div>
                </div>
            </div>
        </section>
    );
}

export default AboutSection;